import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Translation from './translation-model'
import {
  CreateTranslationAsync,
  DeleteTranslationAsync,
  LoadTranslationsAsync,
} from './translation-thunk'
const initialState: translationSliceState = {
  translation: [],
  selected_translation: '',
  is_loading_translation: false,
  is_creating_translation: false,
  is_deleting_translation: false,
}
export interface translationSliceState {
  translation: Translation[]
  selected_translation?: string
  is_loading_translation: boolean
  is_creating_translation: boolean
  is_deleting_translation: boolean
}
export const translationSlice = createSlice({
  name: 'translation',
  initialState,
  reducers: {
    setSelectedtranslation: (state, action) => {
      state.selected_translation = action.payload
    },
    clearStatetranslation: (state) => {
      state.translation = []
      state.is_loading_translation = false
      state.is_creating_translation = false
      state.is_deleting_translation = false
    },
    mergetranslation: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_translation = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.translation = merge(state.translation, payload) as any
        }
      }
    },

    add_translation: (state, action) => {
      if (action.payload) {
        state.translation = [...state.translation, action.payload]
      }
    },
    set_translation: (state, action) => {
      let { key, value, id } = action.payload
      state.translation = state.translation.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadTranslationsAsync.pending, (state) => {
      state.is_loading_translation = true
    })
    builder.addCase(LoadTranslationsAsync.fulfilled, (state, action) => {
      state.is_loading_translation = false
      if (action.payload) {
        state.translation = action.payload
      }
    })
    builder.addCase(LoadTranslationsAsync.rejected, (state) => {
      state.is_loading_translation = false
    })
    builder.addCase(CreateTranslationAsync.pending, (state) => {
      state.is_creating_translation = true
    })
    builder.addCase(CreateTranslationAsync.fulfilled, (state) => {
      state.is_creating_translation = false
    })
    builder.addCase(CreateTranslationAsync.rejected, (state) => {
      state.is_creating_translation = false
    })
    builder.addCase(DeleteTranslationAsync.pending, (state) => {
      state.is_deleting_translation = true
    })
    builder.addCase(DeleteTranslationAsync.fulfilled, (state, action) => {
      state.is_deleting_translation = false
      if (state.translation) {
        state.translation = state.translation.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteTranslationAsync.rejected, (state) => {
      state.is_deleting_translation = false
    })
  },
})

export const {
  clearStatetranslation,
  setSelectedtranslation,
  set_translation,
  mergetranslation,
  add_translation,
} = translationSlice.actions

export const get_translation =
  (id?: string) =>
  (state: {
    translation: {
      translation: Translation[]
    }
  }): Translation | null => {
    let temp = state?.translation?.translation?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.translation?.translation[0] || null
  }
export const get_selected_translation = (state: {
  translation: translationSliceState
}): Translation | null => {
  let id = state?.translation?.selected_translation
  let temp = state?.translation?.translation?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_translation = (state: {
  translation: {
    translation: Translation[]
  }
}): Translation[] => {
  let temp = state?.translation?.translation
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_translation_busy = (state: {
  translation: translationSliceState
}) => {
  return (
    state?.translation.is_deleting_translation ||
    state?.translation.is_loading_translation ||
    state?.translation.is_creating_translation
  )
}
export const is_deleting_translation_busy = (state: {
  translation: translationSliceState
}) => {
  return state?.translation.is_deleting_translation
}
export const is_loading_translation_busy = (state: {
  translation: translationSliceState
}) => {
  return state?.translation.is_loading_translation
}
export const is_creating_translation_busy = (state: {
  translation: translationSliceState
}) => {
  return state?.translation.is_creating_translation
}

export default translationSlice.reducer
